import { isAfter, isBefore } from 'date-fns';

import { fromUTC } from '@klp/helpers';
import type { IMessage } from '@klp/messageboard/classes';
import { MessageStatus } from '@klp/messageboard/classes';

export interface IFrontpageMessageInput {
    id: IMessage['id'];
    expiresAt: IMessage['expiresAt'];
    publishedAt: IMessage['publishAt'];
    title: IMessage['title'];
    status: IMessage['status'];
    category: string;
}

export class FrontpageMessage implements IFrontpageMessageInput {
    public static parseObject(obj: IFrontpageMessageInput): FrontpageMessage {
        try {
            return new FrontpageMessage(obj);
        } catch (e) {
            throw new Error(
                `Couldn't parse object: ${JSON.stringify(obj)} ${e}`,
            );
        }
    }

    public id: IFrontpageMessageInput['id'];
    public expiresAt: IFrontpageMessageInput['expiresAt'];
    public publishedAt: IFrontpageMessageInput['publishedAt'];
    public title: IFrontpageMessageInput['title'];
    public status: IFrontpageMessageInput['status'];
    public category: IFrontpageMessageInput['category'];

    public get getStatus() {
        const { status, messageExpired, messageWillPublish } = this;
        const { Expired, Published, WillPublish } = MessageStatus;

        if (status === Published && messageExpired) {
            return Expired;
        } else if (status === Published && messageWillPublish) {
            return WillPublish;
        }

        return status;
    }

    public get messageExpired() {
        return this.expiresAt ? isBefore(this.expiresAt, new Date()) : false;
    }

    public get messageWillPublish() {
        return this.publishedAt ? isAfter(this.publishedAt, new Date()) : false;
    }

    constructor(obj: IFrontpageMessageInput) {
        const { id, expiresAt, publishedAt, status, title, category } = obj;

        this.id = id;
        this.title = title;
        this.expiresAt = expiresAt ? fromUTC(expiresAt) : undefined;
        this.publishedAt = publishedAt ? fromUTC(publishedAt) : undefined;
        this.status = status;
        this.category = category;
    }
}
